<template>
  <div class="col-md-3 col-sm-12 col-xs-12">
    <div v-if="titulo">{{ titulo }}</div>
    <q-select
      dense
      outlined
      v-model="unidade"
      :options="listaUnidades"
      :option-label="
        (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
      "
    >
    </q-select>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "SelectUnidades",
  props: ["titulo", "icon"],
  emits: ["emitirUnidade"],

  setup(props, { emit }) {
    const store = useStore();
    const unidade = ref({
      id: "",
      nome: "",
    });

    const listaUnidades = ref([]);

    let listarUnidades = async () => {
      try {
        let resposta = await store.dispatch("org/listarUnidades");

        listaUnidades.value = resposta.listaUnidades;
      } catch (error) {
        console.error(error);
      }
    };

    watch(unidade, () => {
      emitirUnidade(unidade);
    });

    let emitirUnidade = async (unidade) => {
      emit("emitirUnidade", unidade);
    };

    // let getUnidade = async () => {
    //   unidade.value.id = store.state.org.unidadeData.id;
    //   unidade.value.nome = store.state.org.unidadeData.nome;

    // };

    onMounted(() => {
      listarUnidades();
      //getUnidade();
    });

    return {
      unidade,
      emitirUnidade,
      listaUnidades,
      listarUnidades,
      //getUnidade,
    };
  },
};
</script>
